module.exports = __webpack_public_path__ + "img/RSpearman64_ua.a3090992.webp";